import UAParser, { IResult } from 'ua-parser-js';
import { NextPageContext } from 'next';

/**
 CloudFront Device Type Headers
 CloudFront-Is-Tablet-Viewer
 CloudFront-Is-Android-Viewer
 CloudFront-Is-IOS-Viewer
 CloudFront-Is-Desktop-Viewer
 CloudFront-Is-Mobile-Viewer
 */

const deviceDetect = async (ctx: NextPageContext) => {
  const { req } = ctx || {};
  const { headers } = req || {};
  let platform = 'desktop';
  let os = '';

  if (
    process.env.NEXT_PUBLIC_ENV === 'production' ||
    process.env.NEXT_PUBLIC_ENV === 'staging'
  ) {
    const {
      'cloudfront-is-tablet-viewer': tablet,
      'cloudfront-is-mobile-viewer': mobile,
      'cloudfront-is-android-viewer': android,
      'cloudfront-is-ios-viewer': iOS,
    } = headers || {};

    if (tablet === 'true') {
      platform = 'tablet';
    } else if (mobile === 'true') {
      platform = 'mobile';
    }

    if (android === 'true') {
      os = 'Android';
    } else if (iOS === 'true') {
      os = 'iOS';
    }
  } else {
    const { 'user-agent': serverUserAgent } = headers || {};
    const userAgent = req ? serverUserAgent : navigator.userAgent;
    const parser = new UAParser(userAgent);
    const { device, os: userAgentOS }: IResult = parser.getResult();
    platform = device.type || 'desktop';
    os = userAgentOS.name || '';
  }

  return { os, platform };
};

export default deviceDetect;
